import JWTAuth from './jwt';
import BasicAuth from './Basic';

export const AuhMethods = {
  jwtAuth: JWTAuth,
  basic: BasicAuth,
};
